// extracted by mini-css-extract-plugin
export default {"customTopbarButton":"CustomTopbarButton_customTopbarButton__ZB4Pa","label":"CustomTopbarButton_label__lOTQ- textSmall","icon":"CustomTopbarButton_icon__jPOPk"};